import { FieldBase, IFieldOptions } from './field-base.interface'
import { IMCC, MCCType } from './mcc-select.interface'

export class MCCSelectField extends FieldBase<IMCC> {
  controlType = 'mcc'
  mccType: MCCType

  constructor(options: IFieldOptions<IMCC> = {}) {
    super(options)
    this.mccType = options['mccType'] || MCCType.Standard
  }
}
